//const ALL_URL = { api_url: "https://localhost:44383/api/" };

const ALL_URL = { api_url: "https://api.thercss.com/api/" };

export default ALL_URL;
